import Axios from './axios_wrapper'

export function getTranslations(locale) {
  return Axios({
    url: `/${locale}/unsubscribe`,
    method: 'GET'
  })
}


//////////////////
// WEBPACK FOOTER
// ../raypro_ui/src/api/unsubscribe_translations.js
// module id = null
// module chunks = 